import { Box, Heading, Select, SimpleGrid } from '@hover/blueprint';
import React from 'react';
import { IDepartment } from '../../../interfaces/IDepartment';
import { IOffice } from '../../../interfaces/IOffice';

interface Props {
  departments: IDepartment[];
  offices: IOffice[];
  setSelectedLocation: React.Dispatch<React.SetStateAction<string>>;
  setSelectedTeam: React.Dispatch<React.SetStateAction<string>>;
}

const Header: React.FC<Props> = ({
  departments,
  offices,
  setSelectedLocation,
  setSelectedTeam,
}) => (
  <Box flexDir="column" w="100%" alignItems="center">
    <Heading
      size={700}
      style={{ fontWeight: 600 }}
      marginBottom={{ base: 500, desktop: '82px' }}
      mr={{ base: 0, desktop: '110px' }}
      as="h2"
    >
      Open roles
    </Heading>
    <SimpleGrid
      w={{ base: '100%', tablet: 'auto' }}
      spacingY={300}
      spacingX={500}
      columns={{ base: 1, tablet: 2 }}
      mb={600}
      alignSelf={{ base: 'center', desktop: 'flex-start' }}
    >
      <Select
        w={{ base: '100%', tablet: '276px' }}
        onChange={({ target: { value } }) => setSelectedTeam(value)}
      >
        <option value="all teams" key="all teams">
          TEAMS
        </option>
        {departments.map(department => (
          <option value={department.name} key={department.id}>
            {department.name}
          </option>
        ))}
      </Select>
      <Select
        w={{ base: '100%', tablet: '276px' }}
        onChange={({ target: { value } }) => setSelectedLocation(value)}
      >
        <option value="all locations" key="all locations">
          LOCATIONS
        </option>
        {offices.map(office => (
          <option value={office.name} key={office.id}>
            {office.name}
          </option>
        ))}
      </Select>
    </SimpleGrid>
  </Box>
);

export default Header;
